module.exports = __webpack_public_path__ + "img/GE_bottom_right.4c5d747e.jpg";